import { Directive, ElementRef, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { AuthService } from '@services/auth/auth.service';
import * as _ from 'lodash';

@Directive({
  standalone: false,
  selector: '[appAllowedAccess]',
})
export class AllowedAccessDirective {
  constructor(
    private auth: AuthService,
    private templateRef: TemplateRef<ElementRef>,
    private viewContainer: ViewContainerRef
  ) {}

  @Input() public set appAllowedAccess(requiredAbilities) {
      const hasAnyPermission = this.auth.hasAnyAbility(requiredAbilities);
      if (hasAnyPermission || _.isEmpty(requiredAbilities)) {
        this.viewContainer.createEmbeddedView(this.templateRef);
      } else {
        this.viewContainer.clear();
      }
  }
}
